import type { WishlistBookmarkPayload } from './types'

export function buildWishlistFingerprint(item: WishlistBookmarkPayload): string {
  switch (item.type) {
    case 'hotel':
    case 'tactical_ao_hotel':
    case 'bedbank_hotel':
    case 'rental':
      return [item.type, item.code, item.roomTypeId ?? item.packageId ?? 'default'].join(':')
    case 'tour':
    case 'tour_v2':
      return [item.type, item.code, item.subCode ?? 'default'].join(':')
    case 'bundle_and_save':
      return [item.type, item.code, item.bundlePackageId ?? 'default'].join(':')
    case 'experience':
    case 'cruise_v2':
      return [item.type, item.code].join(':')
    case 'flight':
      return [
        item.type,
        `${item.occupancy.adults}:${item.occupancy.childrenAge.join(',')}`,
        item.journeys
          .map((journey) =>
            [
              journey.originAirportCode,
              journey.destinationAirportCode,
              journey.startDate,
              journey.startTime ?? '',
              journey.endDate ?? '',
              journey.endTime ?? '',
              journey.class,
              journey.flightNumber ?? '',
            ].join('|'),
          )
          .join('>'),
      ].join(':')
    case 'last_minute_hotel':
      return [item.type, 'unsupported'].join(':')
  }
}
